import { render, staticRenderFns } from "./BindDemo.vue?vue&type=template&id=80550c86&scoped=true"
import script from "./BindDemo.vue?vue&type=script&lang=ts"
export * from "./BindDemo.vue?vue&type=script&lang=ts"
import style0 from "./BindDemo.vue?vue&type=style&index=0&id=80550c86&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80550c86",
  null
  
)

export default component.exports